import Video, {IVideo} from 'app/components/tv/models/video';

const START_OFFSET = 7;
const VIDEO_DURATION = 25;

export default class StaigeVideo extends Video {
  constructor(data: IVideo) {
    super(data);
  }

  get startTime(): number {
    return this.startSec ? this.startSec - START_OFFSET : 0;
  }

  get videoDuration(): number {
    return VIDEO_DURATION;
  }

  isSeekable(): boolean {
    return false;
  }

  showFuPaTvLogo(): boolean {
    return true;
  }
}
